export default import.meta.ROLLDOWN_FILE_URL_o5PevGaCqWe6v5EiRsSaNQ